export default __webpack_public_path__ + "static/media/canvas_placeholder.aea9bb0b.gif";